const todos = [
    {
        id: 1,
        member: 'Alice Mayer',
        task: 'Call Sam For payments',
        priority: 'high',
        status: 'finished'
    },
    {
        id: 2,
        member: 'Kate Moss',
        task: 'Make payment to Bluedart',
        priority: 'low',
        status: 'unfinished'
    },
    {
        id: 3,
        member: 'Danny McChain',
        task: 'Office rent',
        priority: 'middle',
        status: 'unfinished'
    }
]
export default todos
